<template>
    <div>
        <div class="d-flex align-items-center justify-content-between">
            <ul class="nav nav-pills bg-white" role="tablist">
                <li class="nav-item" v-if="$can('read-wallet-list', 'wallet')" role="presentation">
                    <a :class="['nav-link', active_tab === 'wallets' ? 'active' : '']"
                    @click="setTab('wallets')"
                    href="#"
                    id="wallets-tab"
                    role="tab"
                    >
                        <span v-text="$t('wallets.label.wallet_list')"></span>
                    </a>
                </li>
                <li class="nav-item" v-if="$can('read-settlement-and-charge-list', 'wallet')" role="presentation">
                    <a :class="['nav-link', active_tab === 'transactions' ? 'active' : '']"
                    @click="setTab('transactions')"
                    href="#"
                    id="transactions-tab"
                    role="tab"
                    >
                        <span v-text="$t('wallets.label.transaction_list')"></span>
                    </a>
                </li>
                <li class="nav-item" v-if="$can('read-settlement-and-charge-list', 'wallet')" role="presentation">
                    <a :class="['nav-link', active_tab === 'settlements' ? 'active' : '']"
                    @click="setTab('settlements')"
                    href="#"
                    id="settlements-tab"
                    role="tab"
                    >
                        <span v-text="$t('wallets.label.settlement_list')"></span>&nbsp;
                    </a>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane fade show active"
                 id="wallets"
                 role="tabpanel"
                 v-if="active_tab === 'wallets'">
                <wallet-list :prop_user_hashid="user_hashid" :fetch_starshop="fetch_starshop" :api_base_path="api_base_path"></wallet-list>
            </div>
            <div class="tab-pane fade show active"
                 id="transactions"
                 role="tabpanel"
                 v-if="active_tab === 'transactions'">
                <transaction-list :prop_user_hashid="user_hashid" :fetch_starshop="fetch_starshop" :api_base_path="api_base_path"></transaction-list>
            </div>
            <div class="tab-pane fade show active"
                 id="settlements"
                 role="tabpanel"
                 v-if="active_tab === 'settlements'">
                <settlement-list :prop_user_hashid="user_hashid" :fetch_starshop="fetch_starshop" :api_base_path="api_base_path"></settlement-list>
            </div>
        </div>
    </div>
</template>

<script>
    import WalletList from "@/views/wallets/AyandeWallets/Admin/components/wallet-list.vue";
    import SettlementList from "../components/settlement-list.vue";
    import TransactionList from "@/views/wallets/AyandeWallets/Admin/components/transaction-list.vue";
    import {ApiUrl} from "@/common/api.service";

    export default {
        components: {
            TransactionList,
            SettlementList,
            WalletList,
        },
        data() {
            return {
                active_tab: "wallets",
                fetch_starshop: false,
                api_base_path: ApiUrl.starshopPath('')
            };
        },
        props:{
            user_hashid : {
                required :true
            }
        },
        methods: {
            setTab(selected_tab) {
                this.active_tab = selected_tab;
            },
        },
        watch: {
            fetch_starshop(newValue, oldValue) {
                const current_tab = this.active_tab;
                this.active_tab = "";
                this.$nextTick(() => {
                    this.active_tab = current_tab;
                });
            }
        },

    }
</script>

<style scoped>
</style>
